<template>
    <div>
        <div class="crossprice" v-if="
                                  ((variation.prices.rrp && variation.prices.rrp.unitPrice.value > 0) &&
                                  variation.prices.rrp.unitPrice.value > variation.prices.default.unitPrice.value) || variation.prices.specialOffer != null">
          <del class="text-muted small">
            <template v-if="variation.variation.minimumOrderQuantity == 0.1">
              {{ (variation.prices.rrp.unitPrice.value  * (variation.variation.minimumOrderQuantity * 5))  | currency(variation.prices.default.currency)  }}
            </template>
            <template v-else>
              {{ (variation.prices.rrp.unitPrice.value  * variation.variation.minimumOrderQuantity) | currency(variation.prices.default.currency)  }}
            </template>
          </del>
        </div>
        <span class="price h1 d-inline-block">
            <span ref="variationTotalPrice" :content="variation.prices.default.price.value">
              {{ variation.prices.default.price.value | currency  }}
            </span>
        </span>
        <div class="d-inline-block base-price text-muted my-3 vatBox ml-2">
            <span class="vat text-muted">
                <span v-if="variation.unit && variation.unit.unitOfMeasurement =='MTR'">
                    {{ $translate("Snaply5::Template.singleUnitSlang") }}
                    <span v-if="variation.variation.minimumOrderQuantity == 0.5">
                        {{ variation.variation.minimumOrderQuantity }}
                    </span>
                    <span v-else>
                        {{ variation.unit.content }}
                    </span>
                    {{ variation.unit.names.name }}
                </span>
                <template v-if="shownet">
                    {{ $translate("Ceres::Template.singleItemExclVAT") }}
                </template>
                <template v-else>
                    {{ $translate("Ceres::Template.singleItemInclVAT") }}
                </template>
            </span>
            <span v-if="variation.variation.mayShowUnitPrice">
                ({{ $translate("Ceres::Template.singleItemUnitPrice") }}&nbsp;<span class="base-price-value">{{ baseprice }}</span>)
            </span>

        </div>

        <div class="choosen-colors" @click="showSideBar()">
            <template v-if="fullItems.length > 0">
                <div v-for="(color,index) in fullItems" v-if="index <= 3">
                    <div>
                        <img :src="color.data.images.all[0].urlPreview" class="img-fluid" :alt="color.data.texts.name1" :title="color.data.texts.name1">
                    </div>
                </div>
            </template>
            <template v-else>
                <div>
                    <div>
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC" class="img-fluid">
                    </div>
                </div>
                <div>
                    <div>
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC" class="img-fluid">
                    </div>
                </div>
                <div>
                    <div>
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC" class="img-fluid">
                    </div>
                </div>
                <div>
                    <div>
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC" class="img-fluid">
                    </div>
                </div>
            </template>
            <div class="lot-more-colors">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-7">
                <div class="btn btn-block btn-primary btn-danger d-flex align-items-center justify-content-center" @click="showSideBar()">
                    <i class="fa fa-check" v-if="fullItems.length > 0"></i>
                    <i class="fa fa-spin fa-circle-o-notch" v-else></i>
                    <span class="flex-fill">
                        <template v-if="fullItems.length > 0">
                            {{ $translate("Snaply5::Template.singleChooseFromXColors",{"colorCount": fullItems.length }) }}
                        </template>
                        <template v-else>
                             {{ $translate("Snaply5::Template.singleColorLoading") }}
                        </template>
                    </span>
                </div>
            </div>
        </div>

        <div class="sidebar-color-select">
            <div class="sidebar-header">
                <div class="row">
                    <div class="col-6">
                        <div class="title mb-lg-2">
                            {{ $translate("Snaply5::Template.singleColorSelect") }}
                        </div>
                    </div>
                    <div class="col-6 text-right" @click="closeColors()">
                        <i class="snaply-close blue"></i>
                    </div>
                </div>
                <div class="row mb-2 mb-lg-3 align-items-center">
                    <div class="col-12 col-lg-6 mb-2">
                        <div class="sub-title blue">
                            {{ $translate("Snaply5::Template.singleColorMultiSelect") }}
                        </div>
                    </div>
                    <div class="col-7 col-lg-6">
                        <a href="#" class="btn btn-outline-primary btn-block rounded mb-3 mb-lg-0" @click="selectAll()">
                             <template v-if="buyAll == false">
                                 {{ $translate("Snaply5::Template.singleColorSelectAll") }} <i class="fa fa-angle-right"></i>
                             </template>
                            <template v-else>
                                {{ $translate("Snaply5::Template.singleColorDeSelectAll") }} <i class="fa fa-angle-right"></i>
                            </template>
                        </a>
                    </div>
                    <div class="col-5 col-lg-12 p-l-0 pl-lg-3 mt-lg-3 mb-3 mb-lg-0" v-if="fullItems.length > 30">
                        <input type="text" :placeholder="$translate('Snaply5::Template.singleColorSearchPlaceholder')" class="farb-suche" @keyup="filterItems($event)">
                    </div>
                </div>
            </div>
            <div class="sidebar-items">
                <div class="row">
                    <div class="col-4 col-md-3 mb-1" v-for="color in fullItems" :class="{'d-none': searchActive && color.searched===false}"  :data-variation-id="color.id">
                        <div class="variation">
                            <div class="variation-image">
                                <template v-if="color.data.stock.net > 0">
                                    <i class="snaply-close" v-if="color.active" @click="addColor(color)"></i>
                                    <template v-if="color.data.prices.rrp.price.value > color.data.prices.default.price.value">
                                      <div class="special-tags">
                                        <span class="badge badge-offer badge-info">
                                          {{ percent(color) }}
                                        </span>
                                      </div>
                                    </template>
                                    <div class="lazy-click-container cursor" @click="addColor(color)">
                                        <lazy-img   :image-url="color.data.images.all[0].urlPreview"
                                                    class="wrap-img-fluid"
                                                    :alt="color.data.texts.name2"
                                                    :title="color.data.texts.name2"
                                                    >
                                        </lazy-img>
                                    </div>
                                    <input type="number" v-model.number="color.quantity" v-if="color.active" @change="changeInputVal(color)">
                                </template>
                                <template v-else>
                                    <div class="lazy-click-container cursor reminder-wrapper" @click="addToEmailReminderList(color)" @mouseover.once="$store.dispatch('loadComponent', 'email-reminder')">
                                        <i class="fa fa-envelope"></i>
                                        <lazy-img   :image-url="color.data.images.all[0].urlPreview"
                                                    class="wrap-img-fluid"
                                                    :alt="color.data.texts.name2"
                                                    :title="color.data.texts.name2"
                                        >
                                        </lazy-img>
                                    </div>
                                </template>
                            </div>
                            <p class="name">
                                {{ color.data.texts.name2 }}<br>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sidebar-footer">
                <div class="row">
                    <div class="col-12">
                        <div class="text-center">
                            <span class="sidebar-item-count">{{ itemCount }}</span> {{ $translate("Snaply5::Template.singleColorItemSum") }} <span class="sidebar-price-count">{{ priceAll | currency }}</span>
                        </div>
                        <div class="d-flex">
                          <a href="#" class="btn btn-primary btn-danger btn-block select-colors" @click="colorsToCart()">
                              <i class="snaply-shopping-bag"></i>
                              {{ $translate("Ceres::Template.singleItemAddToBasket") }}
                          </a>
                          <template v-if="$store.state.user.userData !== null">
                            <a style="color:white" class="btn-primary btn ml-2 btnAddtoList d-flex justify-content-center" @click="emitCartSave" :class="{ 'disabledAnchor disabled' : this.varsToBuy.length < 1 }" >
                              <i class="snaply-like" aria-hidden="true"></i>
                            </a>
                          </template>
                          <template v-else>
                            <a style="color:white" class="btn-primary btn ml-2 btnAddtoList d-flex justify-content-center"data-testing="login-select"  :href="'#login'" :data-toggle="'modal'" @mouseover.once="$store.dispatch('loadComponent', 'login-modal')" :class="{ 'disabledAnchor disabled' : this.varsToBuy.length < 1 }" >
                              <i class="snaply-like" aria-hidden="true"></i>
                            </a>
                          </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="color-select-greybg" @click="closeColors()"></div>
    </div>
</template>

<script>
    export default
    {
        props:
        {
            template:
            {
                type: String,
                default: "#vue-color-select"
            },
            free:
            {
                type:String,
                default:null
            },
            baseprice:
            {
                type:String,
                default:null
            },
            itemid:
            {
                type:Number,
                default:0
            },
            shownet:
            {
                type:Boolean,
                default:false
            },
            variation:
            {
                type:Object,
                default:null
            }
        },
        data: function()
        {
            return{
                items:[],
                fullItems:[],
                varsToBuy:[],
                priceAll:0,
                itemCount:0,
                buyAll: false,
                searchActive:false,
                urlParams:null

            }
        },
        mounted() {
          let _self = this;
          vueEventHub.$on("emptyVars", data =>
              {

                for(let i = 0; i < this.fullItems.length; i++)
                {
                  this.fullItems[i].active = false;
                }
                this.buyAll = false
                this.varsToBuy = [];
                this.getPricesAndQuantity();
              });
        },
      created:function()
        {
            this.umwandeln();
        },
        methods:
        {
            emitCartSave : function ()
            {
              let _self = this;
              _self.$store.commit('setItems',_self.varsToBuy);
              $('#addToList').modal('show');
            },
            colorsToWishList: function()
            {
              for(let i = 0; i < this.varsToBuy.length; i++)
              {
                this.$store.dispatch("addToWishList",this.varsToBuy[i].id)
              }
              this.closeColors();
            },
            percent: function(color)
            {
              return '- '+(((color.data.prices.rrp.price.value - color.data.prices.default.price.value) / color.data.prices.rrp.price.value)*100).toFixed(0)+' %'
            },
            addToEmailReminderList:function(color)
            {
                vueEventHub.$emit("email-reminder",color);
                $('#emailNoteModal').modal('show')
            },
            colorsToCart:function()
            {
                let _self = this;

                this.$store.dispatch("loadComponent", "add-item-to-basket-overlay");
                this.$store.dispatch("loadComponent", "basket-preview");
                if(this.varsToBuy.length > 0)
                {
                  this.$store.commit("setManyBasketItems",this.varsToBuy);
                }
                let length = this.varsToBuy.length;

                for(let i = 0; i < this.varsToBuy.length; i++)
                {
                    let data =
                        {
                            "variationId":this.varsToBuy[i].id,
                            "quantity": this.varsToBuy[i].quantity
                        }
                    $.ajax(
                        {
                            type: 'POST',
                            url: '/rest/io/basket/items/',
                            data: data,
                            success: function (responseData)
                            {
                              if (i === length - 1)
                              {
                                let response = JSON.parse(responseData);
                                let basketItems = response.events.AfterBasketChanged.basketItems

                                // console.log(' -------------------------------------------------------------------- dispatch w Details')

                              }
                            },
                            error: function (jqXHR, textStatus, errorThrown)
                            {
                                // console.error(errorThrown);
                            }
                        });
                }
                this.closeColors();
            },
            closeColors: function()
            {
                $('.color-select-greybg').removeClass('d-block');
                $('body').removeClass('open-color-select');
            },
            showSideBar: function()
            {
                if($('body').hasClass('open-color-select'))
                {
                    $('body').removeClass('open-color-select');
                    $('.color-select-greybg').addClass('d-block');
                }
                else
                {
                    $('body').addClass('open-color-select');
                    $('.color-select-greybg').removeClass('d-block');
                }
            },
            filterItems: function(event)
            {

                let searched = event.target.value;
                if(searched.length > 0)
                {
                    this.searchActive = true
                }
                else
                {
                    this.searchActive = false
                    for(let i=0; i<this.fullItems.length; i++)
                    {

                       this.fullItems[i].searched = false
                    }
                }

                for(let i=0; i<this.fullItems.length; i++)
                {
                    let name = this.fullItems[i].data.texts.name2.toUpperCase();
                    if(name.indexOf(searched.toUpperCase()) > -1)
                    {
                        this.fullItems[i].searched = true
                    }
                    else
                    {
                        this.fullItems[i].searched = false
                    }
                }
            },
            selectAll: function()
            {
                if(this.buyAll == false)
                {
                    for(let i = 0; i < this.fullItems.length; i++)
                    {
                        this.fullItems[i].active = true;
                        this.varsToBuy.push(this.fullItems[i])
                    }
                    this.buyAll = true;
                    this.getPricesAndQuantity();
                }
                else
                {
                    for(let i = 0; i < this.fullItems.length; i++)
                    {
                        this.fullItems[i].active = false;
                    }
                    this.buyAll = false
                    this.varsToBuy = [];
                    this.getPricesAndQuantity();
                }
            },
            changeInputVal:function(item)
            {
               if(item.quantity > 0)
               {
                   if(item.quantity % item.data.variation.intervalOrderQuantity==0)
                   {
                       if(item.quantity>item.data.stock.net)
                       {
                           item.quantity = item.data.stock.net;
                       }
                       this.getPricesAndQuantity();
                   }
                   else
                   {
                       // Das Intervall muss korrigiert werden

                       let wert = parseInt(item.quantity/item.data.variation.intervalOrderQuantity);
                       wert += item.data.variation.intervalOrderQuantity;
                       item.quantity = wert
                       this.getPricesAndQuantity();
                   }
               }
               else if (item.quantity == 0)
               {
                    item.active     = false;
                    item.quantity   = item.data.variation.intervalOrderQuantity
                    this.getPricesAndQuantity();
               }
               else
               {
                   item.quantity   = item.data.variation.intervalOrderQuantity
                   this.getPricesAndQuantity();
               }
            },
            getPricesAndQuantity: function()
            {
                let activePrices    = 0;
                let itemCount       = 0;
                for(let i = 0; i < this.fullItems.length; i++)
                {
                    if(this.fullItems[i].active == true)
                    {
                        itemCount    = itemCount+this.fullItems[i].quantity;
                        activePrices = activePrices+(this.fullItems[i].quantity*this.fullItems[i].data.prices.default.price.value);
                    }
                }
                this.priceAll  = activePrices;
                this.itemCount = itemCount;
            },
            umwandeln: function()
            {
                this.items = JSON.parse(this.free);
                this.loadItems();
            },
            toggleVariation: function(id)
            {
                for(let i=0; i<this.fullItems.length; i++)
                {
                    if(this.fullItems[i].id === parseInt(id))
                    {
                        this.fullItems[i].active = true;
                    }
                }
            },
            loadItems: function()
            {
                let _self = this;
                let data =
                {
                    items:_self.items
                }

                let myPromise = new Promise(function(myResolve, myReject)
                {
                    $.ajax(
                    {
                        type: 'POST',
                        url: '/getitems/',
                        data: data,
                        success: function (data)
                        {
                            myResolve(data);
                        },
                        error: function (jqXHR, textStatus, errorThrown)
                        {
                            myReject("error");
                        }
                    })

                });

                myPromise.then
                (
                    function(value)
                    {
                        let data = value;
                        for(let i = 0; i < data.length; i++)
                        {
                            data[i].searched    = false;
                            data[i].active      = false;
                            data[i].quantity    = 1;
                        }
                        _self.fullItems = data;
                        vueEventHub.$emit("children-found",data.length);
                        let dataIds = [];
                        for(let i = 0; i < data.length; i++)
                        {
                          dataIds.push(data[i].id);
                        }
                        vueEventHub.$emit('children-ids',dataIds)
                        _self.priceAll  = data[0].data.prices.default.price.value;
                        var search = location.search.substring(1);
                        if(search)
                        {
                            _self.urlParams = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) })
                            if(_self.urlParams.hasOwnProperty('variationId'))
                            {
                                _self.showSideBar();
                                for(let i2 = 0; i2 < _self.fullItems.length; i2++)
                                {
                                  if(parseInt(_self.fullItems[i2].id) === parseInt(_self.urlParams.variationId))
                                  {
                                    _self.addColor(_self.fullItems[i2]);
                                    // --- Scroll hinzufügen ---
                                    _self.$nextTick(() => {
                                      setTimeout(function()
                                      {
                                        let el = document.querySelector(`[data-variation-id="${_self.fullItems[i2].id}"]`);
                                        if(el) {
                                          el.scrollIntoView({ behavior: "smooth", block: "center" });
                                        }
                                      },1000)

                                    });
                                  }
                                }
                            }
                        }

                    },
                    function(error) {
                       console.log(error)
                    }
                );
            },
            addColor: function (variation)
            {

                if(variation.active === false)
                {
                    variation.active = true
                    this.varsToBuy.push(variation)
                }
                else
                {
                    variation.active = false
                    let buyvars = this.varsToBuy;
                    for(let i = 0; i < buyvars.length; i++)
                    {
                        if(variation.id==buyvars[i].id)
                        {
                            buyvars.splice(i, 1);
                        }
                    }
                    this.varsToBuy = buyvars;
                }
                this.getPricesAndQuantity()
            }
        }
    }
</script>
